<template>
  <tr class="cabinet__tbody-row">
    <td class="cabinet__tbody-column">
      {{ date }}
    </td>
    <td class="cabinet__tbody-column">
      {{ typeRus }}
    </td>
    <td class="cabinet__tbody-column">
      {{ name }}
    </td>
    <td class="cabinet__tbody-column">
      {{ objectName }}
    </td>
    <td class="cabinet__tbody-column cabinet__tbody-column--tooltip">
      <a
        v-if="dwnldLink"
        class="dwnld-link"
        :href="dwnldLink"
        target="_blank"
      >
        <span class="tooltip__list-item-img tooltip__list-item-img--paper-download" />
      </a>
    </td>
  </tr>
</template>

<script>
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';

export default {
  name: 'DocumentsTableItem',
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      isOpenPopup: false,
    };
  },
  computed: {
    typeRus() {
      return this.item.typeRus ?? '';
    },
    date() {
      return this.item.date ? dayjs(this.item.date).format('DD.MM.YYYY HH:MM') : '';
    },
    name() {
      return this.item.name;
    },
    objectName() {
      return this.item.objectName || '';
    },
    dwnldLink() {
      const files = this.item.files || [];

      if (!files.length) {
        return '';
      }

      return files[0].src;
    },
  },
};
</script>

<style lang="scss">
.dwnld-link {
  display: block;
  width: 22px;
  height: 22px;

  & span {
    width: 22px;
    height: 22px;
    display: block;
  }
}
</style>
